import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BoltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bolt"}/>
}
